export const getCurrentDatetime = async () => {
    let response = await fetch(
        "https://worldtimeapi.org/api/timezone/America/Mexico_City"
    );
    if (response.ok) {
        response = await response.json();
        return new Date(response.datetime);
    }
}

